import * as React from "react";
import {FormMessage} from "./FormMessage";
import {Spin} from "antd";


export enum FormStates {
  active, handling, success, error
}

interface IProps {
  formState: FormStates;
  formMessage: string;
  successAction: () => void;
  errorAction: () => void;
  children?: React.ReactNode;
}

class FormWrapper extends React.Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {formState, formMessage, successAction, errorAction, children} = this.props;

    if (formState === FormStates.handling) {
      return <Spin size='large' />
    }

    if (formState === FormStates.success) {
      return <FormMessage message={formMessage} actionMsg='Close'
                          action={successAction} />;
    }

    if (formState === FormStates.error) {
      return <FormMessage message={formMessage} actionMsg='Try Again'
                          action={errorAction} />;
    }

    return children;

  }
}

export default FormWrapper;